import React, { useState } from 'react'
import { BellFilled } from '@ant-design/icons'
import styles from './BellNotification.module.scss'
import { useNotificationsSelector } from '../../../store/selectors/notifications'
import MsgList from '../MsgList/MsgList'

const BellNotification: React.FC = () => {
  const { newMsg } = useNotificationsSelector()
  const [isShow, setIsShow] = useState(false)

  const showHandler = () => {
    setIsShow((prev) => !prev)
  }

  return (
    <>
      <div className={styles.container}>
        <BellFilled style={{ fontSize: '20px' }} className={styles.bell} onClick={showHandler} />
        {newMsg > 0 && (
          <div className={styles.label} onClick={showHandler}>
            <span>{newMsg}</span>
          </div>
        )}
        {isShow && (
          <>
            <MsgList showHandler={showHandler} />
            <div className={styles.bg} onClick={showHandler}></div>
          </>
        )}
      </div>
    </>
  )
}

export default BellNotification
